// Resolves { ok: false, incomplete: true } when the buyer has to fix the payment fields; message is
// only set for the CardElement, which shows no errors of its own. Throws anything else.
export default async function checkPaymentDetails({ stripe, elements, readyElement }) {
  const mountedElement = elements.getElement('payment') || elements.getElement('card');

  // Stripe rejects submit() and createToken() with a developer-facing error until the
  // element has emitted ready, and never emits it after a load error.
  if (mountedElement && mountedElement !== readyElement) {
    return { ok: false };
  }

  const { error: submitError } = await elements.submit();

  if (submitError?.type === 'validation_error') {
    return { ok: false, incomplete: true };
  }

  if (submitError) throw submitError;

  // elements.submit() does not check a CardElement, and live payments only reach Stripe after
  // the API has created the charge. createToken rejects an incomplete card without a request.
  const cardElement = elements.getElement('card');
  if (!cardElement) return { ok: true };

  const { error: cardError } = await stripe.createToken(cardElement);

  if (cardError?.type === 'validation_error') {
    return { ok: false, incomplete: true, message: cardError.message };
  }

  if (cardError) throw cardError;

  return { ok: true };
}
